<template>
  <div class="main print-no-padding area">
    <h2 class="is-print-hide title-area">
      <span class="main-title">{{ pageName }}</span>
    </h2>
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/shopManagement' }">门店设置</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/shopManagement/areaList' }">大区设置</el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageName }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <el-form ref="form" :model="form" :rules="rules" :hide-required-asterisk="true">
        <el-form-item class="item" prop="name">
          <template #label>
            <form-label required>大区名称</form-label>
          </template>
          <el-input
            style="width: 200px"
            maxlength="15"
            v-model="form.name"
            placeholder="支持汉字、字母、数字"
          ></el-input>
        </el-form-item>
        <el-form-item class="item" :error="selectStoreError">
          <template #label>
            <form-label required>门店</form-label>
          </template>
          <div class="store-list-wrapper">
            <div class="selected-store">
              <span class="name">已选门店</span>
              <span class="count">{{ `${selectStoreCount}/${totalStoreCount}` }}</span>
            </div>
            <div class="search-bar">
              <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="filterText"></el-input>
            </div>
            <div class="store-list">
              <tree
                ref="tree"
                :data="data"
                show-checkbox
                node-key="id"
                accordion
                @check="selectStore"
                :filter-node-method="filterNode"
              ></tree>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="item" label=" ">
          <el-button class="btn-submit" type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import tree from './components/tree/tree';
import { mergeStoreData } from '@/util';
import formLabel from '@/components/global/form/label';

export default {
  name: 'areaEditor',
  components: {
    tree,
    formLabel
  },
  data() {
    return {
      visible: false,
      form: {
        name: '',
        storeIdList: []
      },
      rules: {
        name: [
          { required: true, message: '请输入大区名称', trigger: ['blur'] },
          {
            validator(rule, value, callback) {
              if (/^[A-Za-z0-9\u4e00-\u9fa5]+$/.test(value)) {
                callback();
              } else {
                callback(new Error('仅支持汉字、英文字符、数字'));
              }
            },
            trigger: ['blur']
          }
        ]
      },
      data: [],
      filterText: '',
      totalStoreCount: 0,
      selectStoreCount: 0,
      selectStoreError: ''
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  computed: {
    pageName() {
      if (this.$route.params.id) return '编辑大区';
      return '新建大区';
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    init() {
      const { id } = this.$route.params;
      if (id) {
        this.getStoreList(id);
        Fetch.getArea(id).then(({ name, storeList = [] }) => {
          this.form.name = name;
          this.form.storeIdList = storeList.map(store => store.id);
          this.$refs.tree.setCheckedKeys(this.form.storeIdList);
          this.selectStoreCount = this.form.storeIdList.length;
        });
      } else {
        this.getStoreList();
      }
    },
    getStoreList(areaId) {
      return Fetch.limitedStoreForArea({ areaId }).then(data => {
        this.data = mergeStoreData(data, data['86'], areaId);
        this.$nextTick(_ => {
          this.totalStoreCount = this.$refs.tree.getNodes(true).length;
        });
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    selectStore() {
      this.selectStoreCount = this.$refs.tree.getCheckedNodes(true).length;
      this.form.storeIdList = this.$refs.tree.getCheckedNodes(true).map(node => node.id);
      if (this.selectStoreCount > 0) {
        this.selectStoreError = '';
      } else {
        this.selectStoreError = '请选择门店';
      }
    },
    submit() {
      const { id } = this.$route.params;
      const { selectStoreCount, form } = this;
      this.$refs.form.validate(valid => {
        if (valid && selectStoreCount > 0) {
          if (id) {
            Fetch.updateArea({ id, companyId: this.$store.getters.companyId, ...form }).then(_ => {
              this.$message.success('更新成功');
              this.$router.push('/shopManagement/areaList');
            });
          } else {
            Fetch.addArea({ companyId: this.$store.getters.companyId, ...form }).then(_ => {
              this.$message.success('新增成功');
              this.$router.push('/shopManagement/areaList');
            });
          }
        } else {
          !selectStoreCount && (this.selectStoreError = '请选择门店');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.area {
  .breadcrumb {
    margin-bottom: 15px;
  }

  .item {
    position: relative;
    display: flex;

    /deep/.el-form-item__label {
      width: 80px;
    }

    /deep/.el-form-item__content {
      display: flex;

      .el-transfer {
        position: relative;
      }
    }

    .el-icon-setting {
      position: absolute;
      top: 0;
      right: -26px;
      font-size: 18px;
      transition: all 0.15s;

      &:hover {
        color: #1e8dff;
        cursor: pointer;
      }
    }

    .store-list-wrapper {
      width: 464px;
      border-radius: 4px;
      border: 1px solid #f2f2f2;

      .selected-store {
        display: flex;
        justify-content: space-between;
        padding: 0 12px;
        color: #707070;
        border-bottom: 1px solid #f2f2f2;
      }

      .search-bar {
        padding: 5px 12px;

        /deep/input {
          border-radius: 32px;
        }
      }

      .store-list {
        height: 400px;
        overflow: auto;
      }
    }

    .btn-submit {
      width: 174px;
    }
  }
}
</style>
